import DefaultSwitchLabels from "./default-switch-labels";
import FormikSwitchLabels from "./formik-switch-labels";
export { FormikSwitchLabels as default, DefaultSwitchLabels };

